import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Transcript = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6.75 15.25H11.25M14.75 15.25H17.25M6.75 11.25H8.25M11.75 11.25H17.25M4.75 4.75H19.25C20.3546 4.75 21.25 5.64543 21.25 6.75V17.25C21.25 18.3546 20.3546 19.25 19.25 19.25H4.75C3.64543 19.25 2.75 18.3546 2.75 17.25V6.75C2.75 5.64543 3.64543 4.75 4.75 4.75Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM6 15.25C6 14.8358 6.33579 14.5 6.75 14.5H12.25C12.6642 14.5 13 14.8358 13 15.25C13 15.6642 12.6642 16 12.25 16H6.75C6.33579 16 6 15.6642 6 15.25ZM15 15.25C15 14.8358 15.3358 14.5 15.75 14.5H17.25C17.6642 14.5 18 14.8358 18 15.25C18 15.6642 17.6642 16 17.25 16H15.75C15.3358 16 15 15.6642 15 15.25ZM6.75 10.5C6.33579 10.5 6 10.8358 6 11.25C6 11.6642 6.33579 12 6.75 12H8.25C8.66421 12 9 11.6642 9 11.25C9 10.8358 8.66421 10.5 8.25 10.5H6.75ZM11.75 10.5C11.3358 10.5 11 10.8358 11 11.25C11 11.6642 11.3358 12 11.75 12H17.25C17.6642 12 18 11.6642 18 11.25C18 10.8358 17.6642 10.5 17.25 10.5H11.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
